import React, { useEffect, useState } from "react";
import axios from "axios";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { apiUrl, assetsUrl } from "../config/Config";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import userplaceholder from '../assets/images/userplaceholder.png';
import { faCoins    
   } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import ProgressBar from "@ramonak/react-progress-bar";
import leftborder from '../assets/images/leftborder.png';
import rightborder from '../assets/images/rightborder.png';
import AOS from "aos";
import { useDispatch, useSelector } from 'react-redux';

  const SubscriptionPage = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const inkcustomerdata = useSelector((store) => store.userReducer.inkcustomerdata);
    const [pricinglist, setpricinglist] = useState([]);
    const [showloading, setshowloading] = useState(false);

    const fetchlayouts = async () => {
      setshowloading(true);
      let resp = await axios.get(apiUrl + "user-getallpricingmodels").then((res) => {
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;
          if (prevdata?.length > 0) {
            setpricinglist(prevdata);
          } else {
            setpricinglist([]);
          }
        } else {
        }
      });
      setshowloading(false);
    };

    const handlecheckout = (id, plan, subtitle, amount) => {
      const checkoutPath = "/checkout/" + id + "/" + encodeURIComponent(subtitle);

      if(inkcustomerdata?.token) {
      //   navigate("/checkout", {
      //   state: {
      //     id: id,
      //     plan: plan,
      //     subtitle: subtitle,
      //     amount: amount
      //   },
      // });
        navigate(checkoutPath);
      } else {
        const basePath = window.location.pathname.replace(/\/subscription-list\/?$/, "");
        localStorage.setItem(
          "frompagetologin",
          window.location.origin + basePath + checkoutPath
        );
        navigate("/login");
      }
      
    }
    console.log('SubscriptionPage inkcustomerdata >>', inkcustomerdata);
    

    useEffect(() => {
        AOS.init({
    
        });
        fetchlayouts();
    }, []);
    
    return (
      <div className="homepage-layout userprofilebg subscriptionpagebg">
        <section>
          <div className="container">
            <div className="howitworkstitlediv customizelayouthowitworksborder">
                <div className="newthinleftborder">
                  <img src={leftborder} className="newleftborder" />
                </div>
                <div className="bordertitlediv">
                  <p>Select Your SlideEZ-Ai Plan </p>
                </div>
                <div className="newthinrightborder">
                  <img src={rightborder} className="newleftborder" />
                </div>
              </div>
              {
                pricinglist?.length > 0 ?
                <div className="subscription-mainrow row">
                  {
                    pricinglist?.map((item, index) => {
                      console.log('pricinglist item >>', item)
                      return (
                        <div className="col-12 col-sm-4 col-md-4" key={index}>
                          <div className="subscription-box">
                            {item?.tag ? (
                              <div className="mostpopularbg">
                                <p>{item?.tag}</p>
                              </div>
                            ) : null}
                            <p className="subscription-title">{item?.title}</p>
                            <p className="subscription-sub-title">
                              {item?.subtitle}
                            </p>
                            {/* <p className="subscription-starts-at">Starts at</p> */}
                            {item?.discountamount == item?.amount ? (
                              <p
                                className="subscription-starts-at"
                                style={{
                                  fontSize: 17
                                }}
                              >
                                &nbsp;
                              </p>
                            ) : (
                              <p
                                className="subscription-starts-at"
                                style={{
                                  fontSize: 17,
                                  textDecoration: "line-through",
                                }}
                              >
                                USD {item?.amount}
                              </p>
                            )}

                            <p className="subscription-price-title">
                              USD {item?.discountamount}
                            </p>
                            <div
                              className="registersubmitbtn "
                              onClick={() => {
                                handlecheckout(
                                  item?.id,
                                  item?.title,
                                  item?.subtitle,
                                  item?.discountamount
                                );
                              }}
                            >
                              {inkcustomerdata?.currentplan == item?.title ? (
                                <p>Renew</p>
                              ) : (
                                <p>Buy</p>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div> 
                :
                showloading ?
                <p><Spinner color="#fff" size={22} className="spinnerCenter" /></p> :
                <p className="no-pricing-modal-text">No data available</p>
              }
            <div className="subscription-mainrow row">
              
            </div>
          </div>
        </section>
      </div>
    );
  }

  export default SubscriptionPage;
